// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"868d826f","227":"51e70175","252":"2e33f5c8","453":"b2188b53","809":"fc9fa870"}[chunkId] + ".chunk.js";
};